<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3>Driver</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-select
        v-model="query.filter"
        :value="query.filter"
        :items="items"
        color="primary"
        class="small-label"
        item-text="name"
        item-value="value"
        label="Filter By"
      />

      <v-text-field
          v-model="query.searchQuery"
          :value="query.searchQuery"
          label="Search by driverId, taxiId, registration number, plate number"
      />

      <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_photos_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {
      rideTypes: null,
      items: [
        { name: "Pending Verification", value: "pending" },
        { name: "Verified", value: "verified" },
        { name: "Rejected", value: "rejected" },
        { name: "Archived", value: "archived" },
        { name: "All", value: "all" },
      ],
    };
  },
  mounted: async function () {},
  methods: {
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
